/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type BankReconciliationPaginatedProperty =
  typeof BankReconciliationPaginatedProperty[keyof typeof BankReconciliationPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BankReconciliationPaginatedProperty = {
  CONFIRMED_AT: 'CONFIRMED_AT',
} as const;
